import React from 'react';
import { Bell, Menu, Repeat2, ShieldCheck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { getInitials } from '../../utils/formatters';

export default function Header({ onMenuClick }) {
  const { user, isAdminDelegatedSession, returnToOwnerSelection } = useAuth();
  const navigate = useNavigate();
  const userName = user?.name || `${user?.firstName || ''} ${user?.lastName || ''}`.trim() || user?.email || 'User';

  function switchOwner() {
    if (returnToOwnerSelection()) {
      navigate('/select-owner');
    }
  }

  return (
    <header className="sticky top-0 z-30 flex h-20 items-center gap-4 bg-[#264D59] px-4 lg:px-6">
      <button onClick={onMenuClick} className="lg:hidden text-white/60 hover:text-white transition-colors"><Menu className="h-6 w-6" /></button>
      <div className="flex-1" />
      {isAdminDelegatedSession && (
        <div className="hidden items-center gap-2 rounded-xl bg-[#F9E07F] px-3 py-2 text-xs font-semibold text-[#264D59] md:flex">
          <ShieldCheck size={15} /> Admin viewing {user?.name || user?.email}
          <button type="button" onClick={switchOwner} className="ml-1 inline-flex items-center border-l border-[#264D59]/20 pl-3 hover:underline">
            <Repeat2 size={14} className="mr-1" /> Switch owner
          </button>
        </div>
      )}
      <button className="relative rounded-full p-1.5 text-white/60 hover:text-white hover:bg-white/10 transition-colors duration-200">
        <Bell className="h-5 w-5" /><span className="absolute top-0.5 right-0.5 h-2 w-2 rounded-full bg-[#F9E07F]" />
      </button>
      <div className="flex items-center gap-3 pl-4 border-l border-white/10">
        <div className="h-9 w-9 rounded-full bg-[#F9E07F] flex items-center justify-center text-[#264D59] text-sm font-bold">
          {getInitials(userName)}
        </div>
        <div className="hidden sm:block">
          <p className="text-sm font-medium text-white">{userName}</p>
          <p className="text-xs text-white/60">{user?.email || ''}</p>
        </div>
      </div>
    </header>
  );
}
